import backSvg from "./icons/back.svg";
import etherScan from "./icons/etherScan.svg";
import ship from "./icons/ship.svg";
import { STORAGE_URL } from "../../constants/index.js";

import CustomArrowDown from "./icons/customArrowDown.jsx";

import EditorAdjust from "./icons/editor/EditorAdjust.jsx";
import EditorCrop from "./icons/editor/EditorCrop.jsx";
import EditorEffect from "./icons/editor/EditorEffect.jsx";
import EditorHome from "./icons/editor/EditorHome.jsx";
import EditorImage from "./icons/editor/EditorImage.jsx";
import EditorText from "./icons/editor/EditorText.jsx";
import EditorTrim from "./icons/editor/EditorTrim.jsx";
import SideBarArrowIcon from "./icons/sideBarArrowIcon.svg";
import SideBarTextIcon from "./icons/sideBarTextIcon.svg";

const dashboard = STORAGE_URL + "bayc-3d/3dTools.svg";
const tutorials = STORAGE_URL + "bayc-3d/tutorials.svg";
const DTools = STORAGE_URL + "bayc-3d/2dTools.svg";
const Analytics = STORAGE_URL + "bayc-3d/analytics.svg";
const ARService = STORAGE_URL + "bayc-3d/ARTools.svg";
const BrandMaker = STORAGE_URL + "bayc-3d/brandMaker.svg";
const Merchandise = STORAGE_URL + "bayc-3d/merchandise.svg";
const chatbot = STORAGE_URL + "bayc-3d/chatBot.svg";
const MetaGameVR = STORAGE_URL + "bayc-3d/files.svg";
const NFTvoiceassistant = STORAGE_URL + "bayc-3d/voiceAssistant.svg";
const StoryBuilder = STORAGE_URL + "bayc-3d/characterBuilder.svg";
const StreamCompanion = STORAGE_URL + "bayc-3d/streamCompanion.svg";

export {
  Analytics,
  ARService,
  NFTvoiceassistant,
  CustomArrowDown,
  StoryBuilder,
  StreamCompanion,
  EditorAdjust,
  BrandMaker,
  EditorCrop,
  Merchandise,
  EditorEffect,
  MetaGameVR,
  SideBarTextIcon,
  chatbot,
  EditorHome,
  backSvg,
  EditorImage,
  ship,
  SideBarArrowIcon,
  EditorText,
  dashboard,
  EditorTrim,
  etherScan,
  DTools,
  tutorials,
};
